export default __webpack_public_path__ + "static/screeny-150-storm-4-8c9aba6b7923e6bb8d8b09b0575fe60e.jpg";